import React from 'react';
import ErrorMessage from './ErrorMessage';

const WIPMessage = () => (
  <ErrorMessage
    className="modal-message aridhia-wip-message"
    error={{
      title: 'feature.coming.soon', message: 'feature.wip', translation: { on: true }, warning: true,
    }}
    icon="ban"
  />
);

export default WIPMessage;
